import { render } from "./ExtrachargeForm.vue?vue&type=template&id=4c9466c4&scoped=true"
import script from "./ExtrachargeForm.vue?vue&type=script&lang=js"
export * from "./ExtrachargeForm.vue?vue&type=script&lang=js"

import "./ExtrachargeForm.vue?vue&type=style&index=0&id=4c9466c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c9466c4"]])

export default __exports__